import { api } from "roboflex-thalamus-request-handler";

export default {
    async dashboard() {
        const response = await api.get("projeto/portfolio/dashboard");
        return response.data;
    },

    async listar(params = {}) {
        const response = await api.get("projeto/portfolio", { params });
        return response.data;
    },

    async detalhe(id) {
        const response = await api.get(`projeto/portfolio/${id}`);
        return response.data;
    },
};
